import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VillaIcon(props: IconProps) {
    return <Icon {...props} iconKey={"villa"}/>
}
